/*
 * Useful to reorder when using react-beautiful-dnd for drag and drop
 */

export function reorder<P>(items: P[], startIndex: number, endIndex?: number): P[] {
  if (endIndex === undefined || endIndex === null) {
    return items;
  }

  const sortedItems = [...items];

  const [removed] = sortedItems.splice(startIndex, 1);
  sortedItems.splice(endIndex, 0, removed);

  return sortedItems.map((item, index) => ({
    ...item,
    rank: index,
  }));
}
